
const languageSettingI18NMap = {
  "en": 'EN',
  "ms": "BM"
}

export const getCurrentLanguageSetting = () => {
  const languageSetting = localStorage.getItem("i18next");

  if (!languageSetting) return 'EN';

  return languageSettingI18NMap[languageSetting] ?? 'EN';
}